import { Session } from "../../types/post";
import { TrainingType } from "../../types/activity";
import { trainingTypeService } from "../../services/trainingTypeService";
import { asDisplayNameOrNull } from "../../utils/displayName";
import { SessionVM } from "./scheduleTypes";

/** Training-type name for a session, with the legacy `sport:type` fallback. */
export const resolveSessionTypeName = (
  session: Pick<Session, "trainingTypeID" | "sessionTypeID">,
  trainingTypes: TrainingType[],
): string | null => {
  const resolved = trainingTypeService.getSessionTrainingTypeName(
    session,
    trainingTypes,
  );
  if (resolved) return resolved;
  const trimmed = session.sessionTypeID?.trim();
  if (trimmed?.includes(":")) return trimmed.split(":")[1] || null;
  return null;
};

/**
 * Session → card view-model without the activity-name lookups the Schedule
 * page adds (Programs detail, Dashboard card). Title falls back to the
 * training type, then "Session".
 */
export const buildSessionVM = (
  session: Session & { id: string },
  trainingTypes: TrainingType[],
): SessionVM => {
  const typeName = resolveSessionTypeName(session, trainingTypes);
  const activityList = session.ActivityMeasurementList || [];
  const timeLabel = session.startTime
    ? new Date(session.startTime).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
    : null;
  return {
    id: session.id,
    title: asDisplayNameOrNull(session.name) || typeName || "Session",
    typeName,
    typeColorKey: session.trainingTypeID || typeName || null,
    exerciseCount: activityList.length,
    completedCount: activityList.filter((m) => m.timeLogged).length,
    linkedTrainingLogID: session.linkedTrainingLogID || null,
    plannedDate: session.plannedDate,
    timeLabel,
    status: session.status,
    isLive: session.status === "executing",
    programName: session.programLinkage?.programName,
    description: session.description,
    coachName: session.coach?.name,
    coachImageUrl: session.coach?.imageUrl,
    coachIssued: session.coachIssued,
    ...(session.eventId ? { eventId: session.eventId } : {}),
  };
};
